import { useMemo } from "react";
import { useWatch } from "react-hook-form";

import { CCol, CRow } from "@coreui/react";

import { CActionGroup } from "_components/others";

export default ({ control, onAdd, onSave, remove, isLoading }) => {
  //#region Data
  const currentMaterials = useWatch({ control, name: "materials" });

  const selected = useMemo(
    () =>
      currentMaterials.reduce((prev, curr, index) => {
        if (curr.checked) prev.push(index);
        return prev;
      }, []),
    [currentMaterials]
  );
  //#endregion

  //#region Event
  const onRemove = () => remove(selected);

  const onClick = (state) => {
    switch (state) {
      case "add":
        return onAdd();
      case "save":
        return onSave();
      case "remove":
        return onRemove();
    }
  };
  //#endregion

  //#region Render
  return (
    <CRow>
      <CCol xs="12" className="action">
        <div>
          <CActionGroup
            onClick={onClick}
            canAdd
            canSave={!isLoading}
            canEdit={false}
            canRemove={selected.length > 0}
          />
        </div>
      </CCol>
    </CRow>
  );
  //#endregion
};
